import { choosePlural } from '@experience/shared/dist/utils/pluralize';
import ru from '../i18n/ru.json';
import { useI18n } from '@experience/i18n';
import { useCategoryStore } from '@/shared/store';
import { EExperienceFilterType } from '@/widgets/filtersBlock/model/interface';
import { ref, computed } from 'vue';

export function useFilterDurationTitle() {
  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });

  const categoryStore = useCategoryStore();

  const DEFAULT_TITLE = t('duration.defaultTitle');

  const headerTitle = ref(t('duration.headerTitle'));

  const PLURAL_DAYS = [t('duration.day_1'), t('duration.day_2'), t('duration.day_2')];

  const title = computed(() => {
    const start = categoryStore.filters[EExperienceFilterType.DURATION].duration[0];
    const end = categoryStore.filters[EExperienceFilterType.DURATION].duration[1];

    if (start === 0 && end === 0) {
      return DEFAULT_TITLE;
    }

    if (start && end === 0) {
      return `${t('duration.fromDay', { day: start })} ${choosePlural(start, PLURAL_DAYS)}`;
    }

    if (end && start === 0) {
      return `${t('duration.toDay', { day: end })} ${choosePlural(end, PLURAL_DAYS)}`;
    }

    if (start && end) {
      return `${t('duration.fromDay', { day: start })} ${t('duration.toDay', { day: end })} ${choosePlural(end, PLURAL_DAYS)}`;
    }

    return DEFAULT_TITLE;
  });

  const isActive = computed(() => title.value !== DEFAULT_TITLE);

  return {
    title,
    headerTitle,
    isActive,
  };
}
